import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskUnassignedTicketTypesConfigRoute: InvariantJiraRoute = {
	exact: true,
	name: 'project-settings-servicedesk-unassigned-ticket-types-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/request-types/unassigned',
};
